/* eslint-disable no-restricted-globals */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { useMemo, memo, useState } from 'react';
import Tabs, { TabPane } from 'rc-tabs';
import { Button } from '@saleshandy/design-system';
import {
  // Diamond,
  Download,
  Mail,
  Phone,
  RemoveList,
  Send,
  UserList,
  Users,
} from '@saleshandy/icons';
// import { useSelector } from 'react-redux';
// import { useHistory } from 'react-router';
import {
  LeadFinderPrimaryTab,
  LeadFinderSecondaryTab,
  BulkLeadsActionType,
  SavedTabFilters,
  LeadFinderListVisibility,
  LeadFinderListTab,
  LeadRevealType,
  V2Lead,
} from '../../types';
import V2AddRemoveTagButton from '../add-remove-tag-button';
// import { RootState } from '../../../../store/root-reducer';
// import { leadFinderViewOnly } from '../../../../shared/utils/user-details';
import GlobalRestrictionModal from '../../../home/components/global-restriction-modal';
import NewBadge from '../../../home/components/sidebar/components/new-badge';
import AddToListDropdown from '../add-to-list-dropdown/add-to-list-dropdown';
import RemoveFromListModal from '../remove-from-list-modal/remove-from-list-modal';
import { hasLeadValidEmail } from '../../helpers/helper';
import {
  OverlayTooltip,
  Placement,
} from '../../../../shared/design-system/components/overlay';
import { getIsDemoAccount } from '../../../../shared/utils/user-details';
import { useCanShowDataExport } from '../../../../shared/utils/data-export-permission';
import { useExportConfirmation } from '../../../../shared/components/export-confirmation/use-export-confirmation';

interface V2LeadHeaderProps {
  activeTab: LeadFinderPrimaryTab;
  activeSubTab: LeadFinderSecondaryTab;
  leadCredits?: number;
  isLoading?: boolean;
  onTabChange?: (tab: LeadFinderPrimaryTab) => void;
  isLoadingBulkFindPeople?: boolean;
  selectedLeadsCount?: number;
  selectedLeads?: number[];
  isSelectedAllLeads?: boolean;
  onBulkAction?: (actionType: BulkLeadsActionType) => void;
  selectedCompaniesCount?: number;
  selectedCompanies?: number[];
  isSelectedAllCompanies?: boolean;
  companiesData?: {
    profiles: Array<{
      id?: number;
      company_id?: number;
      lists?: Array<{ id: number } | number | string>;
      company_list_ids?: string[] | number[];
    }>;
  };
  leadsData?: {
    profiles: Array<{
      id?: number;
      lists?: Array<{ id: number } | number | string>;
      lead_list_ids?: string[] | number[];
      list_ids?: string[] | number[];
      listIds?: string[] | number[];
    }>;
  };
  onCompanyBulkFindPeople?: VoidFunction;
  addToListData?: Array<{
    id: number;
    label: string;
    visibility: LeadFinderListVisibility;
    owner: {
      firstName: string;
      lastName: string;
    };
  }>;
  onAddToList?: (
    listIds: number[],
    shouldEnrich?: boolean,
    newLists?: Array<{ name: string; visibility: string; teamIds?: number[] }>,
    revealType?: LeadRevealType,
  ) => void;
  onRemoveFromList?: (listIds: number[], onSuccess?: () => void) => void;
  onCreateNewList?: () => void;
  addToListOpen?: boolean;
  onAddToListOpenChange?: (
    open: boolean,
    options?: { preserveRowSelection?: boolean },
  ) => void;
  addFromRowCompanyId?: number | null;
  addFromRowLeadId?: number | null;
  addToListModalProps?: {
    teamsList?: any[];
    getTeamsListRequestStatus?: any;
    sendGetTeamsListRequest?: VoidFunction;
    onSaveList?: (
      listId: number | null,
      listName: string,
      isShared: boolean,
      teamIds: number[],
      shouldEnrich?: boolean,
    ) => void;
    isUpdateListLoading?: boolean;
  };
  loadingBulkAction?: {
    loadingAddToProspect: boolean;
    loadingAddToSequence: boolean;
    loadingExport: boolean;
  };
  loadingRemoveFromList?: boolean;
  showRemoveFromListModal?: boolean;
  onRemoveFromListModalClose?: () => void;
  onRequestOpenRemoveFromList?: () => void;
  // Tag button props (only needed for saved tab - people)
  tagButtonProps?: {
    handleAddTag: () => void;
    handleRemoveTag: () => void;
    leadTags: any[];
    selectedLeads: number[];
    selectedLeadObjects?: any[];
    deselectedLeads?: number[];
    leadsFilter: SavedTabFilters;
    setSavedFilters: React.Dispatch<React.SetStateAction<SavedTabFilters>>;
    handleQuery: (args: {
      filterKey: string;
      filterValue: any;
      filterType: string;
    }) => void;
    setSelectedLeads: React.Dispatch<React.SetStateAction<number[]>>;
  };
  defaultEmailRevealType?: string;
  companyTagButtonProps?: {
    handleAddTag: () => void;
    handleRemoveTag: () => void;
    leadTags: any[];
    selectedCompanies: number[];
    selectedCompanyObjects?: any[];
    selectedAllCompanies?: boolean;
    companyFilter?: Record<string, any>;
    leadsFilter: SavedTabFilters;
    setSavedFilters: React.Dispatch<React.SetStateAction<SavedTabFilters>>;
    handleQuery: (args: {
      filterKey: string;
      filterValue: any;
      filterType: string;
    }) => void;
    setSelectedCompanies: React.Dispatch<React.SetStateAction<number[]>>;
    setIsSelectedAllCompanies?: React.Dispatch<React.SetStateAction<boolean>>;
    triggerOpenAddTag?: number | null;
    triggerOpenRemoveTag?: number | null;
    /** If true, render the tag button/modal when opened from row actions even without row selection */
    renderWhenTriggered?: boolean;
    onRowTagModalClosed?: () => void;
    overrideSelectedCompanyObjects?: any[];
  };
}

const V2LeadHeader: React.FC<V2LeadHeaderProps> = ({
  activeTab,
  activeSubTab,
  leadCredits = 0,
  isLoading = false,
  isLoadingBulkFindPeople = false,
  onTabChange,
  selectedLeadsCount = 0,
  selectedLeads = [],
  isSelectedAllLeads = false,
  onBulkAction,
  selectedCompaniesCount = 0,
  selectedCompanies = [],
  isSelectedAllCompanies = false,
  companiesData,
  leadsData,
  onCompanyBulkFindPeople,
  addToListData = [],
  addToListOpen,
  onAddToListOpenChange,
  addFromRowCompanyId,
  addFromRowLeadId,
  onAddToList,
  onRemoveFromList,
  onCreateNewList,
  addToListModalProps,
  loadingBulkAction = {
    loadingAddToProspect: false,
    loadingAddToSequence: false,
    loadingExport: false,
  },
  loadingRemoveFromList = false,
  showRemoveFromListModal: controlledShowRemoveFromListModal,
  onRemoveFromListModalClose,
  onRequestOpenRemoveFromList,
  tagButtonProps,
  companyTagButtonProps,
  defaultEmailRevealType = 'work_email',
}) => {
  const canDisplayDataExport = useCanShowDataExport();
  const { guardExport, exportConfirmationModal } = useExportConfirmation();
  const hasSelectedLeads = selectedLeadsCount > 0 || isSelectedAllLeads;
  const isCompanyTab = activeTab === LeadFinderPrimaryTab.COMPANY;
  const isCsvEnrichmentTab = activeTab === LeadFinderPrimaryTab.CSV_ENRICHMENT;
  const hasSelectedCompanies =
    selectedCompaniesCount > 0 || isSelectedAllCompanies;

  // const history = useHistory();
  // const isLeadFinderViewOnly = leadFinderViewOnly();

  const [
    globalRestrictionModalContent,
    setGlobalRestrictionModalContent,
  ] = useState({
    title: '',
    content: '',
  });

  const [showGlobalRestrictionModal, setShowGlobalRestrictionModal] = useState(
    false,
  );

  const [
    internalShowRemoveFromListModal,
    setInternalShowRemoveFromListModal,
  ] = useState(false);

  const showRemoveFromListModal =
    controlledShowRemoveFromListModal ?? internalShowRemoveFromListModal;
  const setShowRemoveFromListModal =
    onRemoveFromListModalClose != null
      ? (open: boolean) => {
          if (!open) onRemoveFromListModalClose();
        }
      : setInternalShowRemoveFromListModal;
  const handleOpenRemoveFromListModal = () => {
    if (onRequestOpenRemoveFromList) {
      onRequestOpenRemoveFromList();
    } else {
      setInternalShowRemoveFromListModal(true);
    }
  };
  const handleCloseRemoveFromListModal = () => {
    if (onRemoveFromListModalClose) {
      onRemoveFromListModalClose();
    } else {
      setInternalShowRemoveFromListModal(false);
    }
  };

  const isPeopleTab = activeTab === LeadFinderPrimaryTab.PEOPLE;

  const showViewContactButtons = useMemo(
    () =>
      isPeopleTab &&
      (activeSubTab === LeadFinderSecondaryTab.TOTAL ||
        activeSubTab === LeadFinderSecondaryTab.NEW),
    [isPeopleTab, activeSubTab],
  );

  const disableViewContactButtons = useMemo(
    () => isLoading || !hasSelectedLeads,
    [isLoading, hasSelectedLeads],
  );

  const shouldShowSaveAsProspect = useMemo(
    () => isPeopleTab && activeSubTab !== LeadFinderSecondaryTab.NEW,
    [isPeopleTab, activeSubTab],
  );

  const shouldShowAddToSequence = useMemo(
    () =>
      activeSubTab === LeadFinderSecondaryTab.SAVED &&
      !isCompanyTab &&
      !isCsvEnrichmentTab,
    [activeSubTab, isCompanyTab, isCsvEnrichmentTab],
  );

  const shouldDisableSaveAsProspectAndAddToSequence = useMemo(() => {
    if (isCompanyTab) return false;
    if (isSelectedAllLeads) return false;
    if (!selectedLeads?.length || !leadsData?.profiles) return false;
    const selectedLeadObjects = selectedLeads
      .map((id) =>
        leadsData!.profiles!.find(
          (p) => Number((p as V2Lead)?.id) === Number(id),
        ),
      )
      .filter(Boolean) as V2Lead[];
    if (selectedLeadObjects.length < selectedLeads.length) return false;
    if (selectedLeadObjects.length === 0) return false;
    const allHaveInvalidEmail = selectedLeadObjects.every(
      (lead) => !hasLeadValidEmail(lead),
    );
    return allHaveInvalidEmail;
  }, [isCompanyTab, isSelectedAllLeads, selectedLeads, leadsData?.profiles]);

  const shouldShowTag = useMemo(
    () => activeSubTab === LeadFinderSecondaryTab.SAVED && !isCsvEnrichmentTab,
    [activeSubTab, isCsvEnrichmentTab],
  );

  const shouldRenderCompanyTagWhenTriggered = useMemo(() => {
    if (!isCompanyTab) return false;
    if (!companyTagButtonProps?.renderWhenTriggered) return false;
    return (
      companyTagButtonProps.triggerOpenAddTag != null ||
      companyTagButtonProps.triggerOpenRemoveTag != null
    );
  }, [
    isCompanyTab,
    companyTagButtonProps?.renderWhenTriggered,
    companyTagButtonProps?.triggerOpenAddTag,
    companyTagButtonProps?.triggerOpenRemoveTag,
  ]);

  const shouldShowExport = useMemo(
    () => activeSubTab === LeadFinderSecondaryTab.SAVED && !isCsvEnrichmentTab,
    [activeSubTab, isCsvEnrichmentTab],
  );

  const showRemoveFromListButton = useMemo(
    () => activeSubTab === LeadFinderSecondaryTab.SAVED && !isCsvEnrichmentTab,
    [activeSubTab, isCsvEnrichmentTab],
  );

  // const isDemoAccount = useSelector(
  //   (state: RootState) => state?.home.isDemoAccount,
  // );

  const alreadyAddedListIdsForSingleSelection = useMemo((): number[] => {
    if (isCompanyTab) {
      const companyIdToCheck =
        addFromRowCompanyId ??
        (selectedCompanies.length === 1 && selectedCompanies[0]);
      if (!companiesData?.profiles || companyIdToCheck == null) return [];
      const company = companiesData.profiles.find(
        (c) => Number(c?.id ?? c?.company_id) === Number(companyIdToCheck),
      );
      if (!company) return [];
      if (company.lists?.length) {
        return company.lists
          .map((list: any) => Number(list?.id ?? list))
          .filter((id) => !isNaN(id) && id > 0);
      }
      const listIds = company.company_list_ids;
      return Array.isArray(listIds)
        ? listIds.map((id) => Number(id)).filter((id) => !isNaN(id) && id > 0)
        : [];
    }

    if (
      !leadsData?.profiles ||
      (selectedLeads.length !== 1 && !addFromRowLeadId)
    ) {
      return [];
    }
    const leadIdToCheck = addFromRowLeadId ?? selectedLeads[0];
    const lead = leadsData.profiles.find(
      (l) => Number(l?.id) === Number(leadIdToCheck),
    );
    if (!lead) return [];
    if (lead.lists?.length) {
      return lead.lists
        .map((list: any) => Number(list?.id ?? list))
        .filter((id) => !isNaN(id) && id > 0);
    }
    const listIds =
      (lead as any).lead_list_ids ||
      (lead as any).list_ids ||
      (lead as any).listIds;
    return Array.isArray(listIds)
      ? listIds.map((id) => Number(id)).filter((id) => !isNaN(id) && id > 0)
      : [];
  }, [
    isCompanyTab,
    companiesData?.profiles,
    leadsData?.profiles,
    selectedCompanies,
    selectedLeads,
    addFromRowCompanyId,
    addFromRowLeadId,
  ]);

  // const formatLeadCredits = useMemo(() => {
  //   const credits = isLeadFinderViewOnly ? 0 : Number(leadCredits ?? 0);
  //   return formatLeadFinderCredits(credits);
  // }, [leadCredits, isLeadFinderViewOnly]);

  // Filter lists to show combination of all lists from selected companies
  const filteredListsForRemoveModal = useMemo(() => {
    if (isCompanyTab && hasSelectedCompanies && companiesData?.profiles) {
      const getCompanyId = (company: {
        id?: number;
        company_id?: number;
      }): number | null => {
        if (company.id != null) return Number(company.id);
        if (company.company_id != null) return Number(company.company_id);
        return null;
      };

      const extractListIds = (company: {
        lists?: Array<{ id: number } | number | string>;
        company_list_ids?: string[] | number[];
      }): number[] => {
        if (company.lists?.length) {
          return company.lists
            .map((list) => Number((list as any)?.id ?? list))
            .filter((id) => !isNaN(id) && id > 0);
        }
        if (company.company_list_ids?.length) {
          return company.company_list_ids
            .map((id) => Number(id))
            .filter((id) => !isNaN(id) && id > 0);
        }
        return [];
      };

      const selectedCompanyObjects = companiesData.profiles.filter(
        (company) => {
          const companyId = getCompanyId(company);
          return companyId !== null && selectedCompanies.includes(companyId);
        },
      );

      if (selectedCompanyObjects.length === 0) {
        return [];
      }

      const allListIds = new Set<number>();
      selectedCompanyObjects.forEach((company) => {
        extractListIds(company).forEach((id) => allListIds.add(id));
      });

      if (allListIds.size === 0) {
        return [];
      }

      return addToListData.filter((list) => allListIds.has(list.id));
    }

    // If a lead row action triggered the modal, show only lists that lead belongs to
    if (!isCompanyTab && (addFromRowLeadId ?? selectedLeads.length === 1)) {
      const leadIdToCheck =
        addFromRowLeadId ??
        (selectedLeads.length === 1 ? selectedLeads[0] : null);
      if (leadIdToCheck != null && leadsData?.profiles) {
        const lead = leadsData.profiles.find(
          (l) => Number(l?.id) === Number(leadIdToCheck),
        );
        if (!lead) return [];
        const tagIds: number[] = [];
        if (lead.lists?.length) {
          lead.lists.forEach((t: any) => {
            const id = t?.id ?? t;
            if (id != null) tagIds.push(Number(id));
          });
        }
        if (
          tagIds.length === 0 &&
          (lead as any).list_ids &&
          Array.isArray((lead as any).list_ids)
        ) {
          tagIds.push(...((lead as any).list_ids as number[]));
        }
        if (tagIds.length === 0) return [];
        const setIds = new Set(tagIds);
        return addToListData.filter((list) => setIds.has(list.id));
      }
      return [];
    }

    return addToListData;
  }, [
    isCompanyTab,
    hasSelectedCompanies,
    companiesData,
    selectedCompanies,
    addToListData,
    leadsData,
    selectedLeads,
    addFromRowLeadId,
  ]);

  return (
    <>
      <header className="v2-lead-header" data-testid="v2-lead-header">
        <Tabs
          prefixCls="bs-tabs"
          className="bs-tabs-small v2-lead-header__tabs"
          activeKey={activeTab}
          onChange={(key) => {
            onTabChange?.(key as LeadFinderPrimaryTab);
          }}
        >
          <TabPane tab="Companies" key={LeadFinderPrimaryTab.COMPANY} />
          <TabPane tab="People" key={LeadFinderPrimaryTab.PEOPLE} />
          {!getIsDemoAccount() && (
            <TabPane
              tab={
                <span className="v2-lead-header__tab-with-badge">
                  CSV Enrichment
                  <NewBadge className="v2-lead-header__companies-new-badge" />
                </span>
              }
              key={LeadFinderPrimaryTab.CSV_ENRICHMENT}
            />
          )}
        </Tabs>

        <div className="v2-lead-header__actions">
          <div className="v2-lead-header__action-group">
            {isCompanyTab && (
              <Button
                variant="secondary"
                disabled={
                  isLoading || isLoadingBulkFindPeople || !hasSelectedCompanies
                }
                className="btn-custom-secondary v2-lead-header__find-people-btn"
                onClick={onCompanyBulkFindPeople}
                isLoading={isLoadingBulkFindPeople}
              >
                <Users width={16} height={16} />
                <span>View People</span>
              </Button>
            )}

            <>
              {' '}
              {!isCsvEnrichmentTab && (
                <AddToListDropdown
                  lists={addToListData}
                  disabled={
                    isLoading ||
                    (isCompanyTab
                      ? !hasSelectedCompanies
                      : !hasSelectedLeads && !isSelectedAllLeads)
                  }
                  open={addToListOpen}
                  onOpenChange={onAddToListOpenChange}
                  disabledListIds={alreadyAddedListIdsForSingleSelection}
                  onAddToList={onAddToList}
                  onCreateNewList={onCreateNewList}
                  teamsList={addToListModalProps?.teamsList}
                  getTeamsListRequestStatus={
                    addToListModalProps?.getTeamsListRequestStatus
                  }
                  sendGetTeamsListRequest={
                    addToListModalProps?.sendGetTeamsListRequest
                  }
                  onSaveList={addToListModalProps?.onSaveList}
                  isUpdateListLoading={addToListModalProps?.isUpdateListLoading}
                  isCompanyTab={isCompanyTab}
                  activeSubTab={activeSubTab}
                  selectedResourcesCount={
                    isCompanyTab ? selectedCompaniesCount : selectedLeadsCount
                  }
                  availableCredits={leadCredits}
                />
              )}
              {showRemoveFromListButton && (
                <Button
                  variant="secondary"
                  disabled={
                    isLoading ||
                    (isCompanyTab
                      ? !hasSelectedCompanies
                      : !hasSelectedLeads && !isSelectedAllLeads)
                  }
                  className="btn-custom-secondary"
                  onClick={handleOpenRemoveFromListModal}
                >
                  <RemoveList width={16} height={16} />
                  <span>Remove From List</span>
                </Button>
              )}
            </>

            {showViewContactButtons && (
              <>
                <Button
                  variant="secondary"
                  disabled={disableViewContactButtons}
                  className="btn-custom-secondary"
                  onClick={() =>
                    onBulkAction?.(BulkLeadsActionType.REVEAL_EMAIL)
                  }
                >
                  <Mail />
                  <span>
                    {defaultEmailRevealType === 'personal_email'
                      ? 'View Personal Email'
                      : 'View Work Email'}
                  </span>
                </Button>

                <Button
                  variant="secondary"
                  disabled={disableViewContactButtons}
                  className="btn-custom-secondary"
                  onClick={() =>
                    onBulkAction?.(BulkLeadsActionType.REVEAL_EMAIL_PHONE)
                  }
                >
                  <Phone />
                  <span>View Phone</span>
                </Button>
              </>
            )}

            {shouldShowSaveAsProspect &&
              (shouldDisableSaveAsProspectAndAddToSequence ? (
                <OverlayTooltip
                  text="Lead does not have any email address"
                  placement={Placement.Bottom}
                >
                  <Button
                    variant="secondary"
                    disabled={
                      isLoading ||
                      !hasSelectedLeads ||
                      loadingBulkAction.loadingAddToProspect ||
                      shouldDisableSaveAsProspectAndAddToSequence
                    }
                    className="btn-custom-secondary"
                    onClick={() =>
                      onBulkAction?.(BulkLeadsActionType.ADD_TO_PROSPECT)
                    }
                  >
                    <UserList />
                    <span>Save as Prospect</span>
                  </Button>
                </OverlayTooltip>
              ) : (
                <Button
                  variant="secondary"
                  disabled={
                    isLoading ||
                    !hasSelectedLeads ||
                    loadingBulkAction.loadingAddToProspect ||
                    shouldDisableSaveAsProspectAndAddToSequence
                  }
                  className="btn-custom-secondary"
                  onClick={() =>
                    onBulkAction?.(BulkLeadsActionType.ADD_TO_PROSPECT)
                  }
                >
                  <UserList />
                  <span>Save as Prospect</span>
                </Button>
              ))}
            {shouldShowAddToSequence &&
              (shouldDisableSaveAsProspectAndAddToSequence ? (
                <OverlayTooltip
                  text="Lead does not have any email address"
                  placement={Placement.Bottom}
                >
                  <Button
                    variant="secondary"
                    disabled={
                      isLoading ||
                      !hasSelectedLeads ||
                      loadingBulkAction.loadingAddToSequence ||
                      shouldDisableSaveAsProspectAndAddToSequence
                    }
                    className="btn-custom-secondary"
                    onClick={() =>
                      onBulkAction?.(BulkLeadsActionType.ADD_TO_SEQUENCE)
                    }
                  >
                    <Send />
                    <span>Add to Sequence</span>
                  </Button>
                </OverlayTooltip>
              ) : (
                <Button
                  variant="secondary"
                  disabled={
                    isLoading ||
                    !hasSelectedLeads ||
                    loadingBulkAction.loadingAddToSequence ||
                    shouldDisableSaveAsProspectAndAddToSequence
                  }
                  className="btn-custom-secondary"
                  onClick={() =>
                    onBulkAction?.(BulkLeadsActionType.ADD_TO_SEQUENCE)
                  }
                >
                  <Send />
                  <span>Add to Sequence</span>
                </Button>
              ))}
            {tagButtonProps &&
              !isCompanyTab &&
              (shouldShowTag ||
                (tagButtonProps as any).triggerOpenAddTag != null ||
                (tagButtonProps as any).triggerOpenRemoveTag != null) && (
                <V2AddRemoveTagButton
                  mode={LeadFinderListTab.People}
                  handleAddTag={tagButtonProps.handleAddTag}
                  handleRemoveTag={tagButtonProps.handleRemoveTag}
                  disabled={
                    (selectedLeadsCount === 0 && !isSelectedAllLeads) ||
                    !hasSelectedLeads ||
                    isLoading
                  }
                  leadTags={tagButtonProps.leadTags}
                  selectedLeads={tagButtonProps.selectedLeads}
                  selectedLeadObjects={tagButtonProps.selectedLeadObjects}
                  deselectedLeads={tagButtonProps.deselectedLeads}
                  selectedAllLeads={isSelectedAllLeads}
                  setSelectedLeads={tagButtonProps.setSelectedLeads}
                  leadsFilter={tagButtonProps.leadsFilter}
                  setSavedFilters={tagButtonProps.setSavedFilters}
                  handleQuery={tagButtonProps.handleQuery}
                  triggerOpenAddTag={(tagButtonProps as any).triggerOpenAddTag}
                  triggerOpenRemoveTag={
                    (tagButtonProps as any).triggerOpenRemoveTag
                  }
                  onRowTagModalClosed={
                    (tagButtonProps as any).onRowTagModalClosed
                  }
                  overrideSelectedLeadObjects={
                    (tagButtonProps as any).overrideSelectedLeadObjects
                  }
                  onRefreshSavedCount={
                    (tagButtonProps as any).onRefreshSavedCount
                  }
                />
              )}
            {(shouldShowTag || shouldRenderCompanyTagWhenTriggered) &&
              companyTagButtonProps &&
              isCompanyTab && (
                <V2AddRemoveTagButton
                  mode={LeadFinderListTab.Company}
                  handleAddTag={companyTagButtonProps.handleAddTag}
                  handleRemoveTag={companyTagButtonProps.handleRemoveTag}
                  disabled={
                    (selectedCompaniesCount === 0 &&
                      !isSelectedAllCompanies &&
                      companyTagButtonProps.triggerOpenAddTag == null &&
                      companyTagButtonProps.triggerOpenRemoveTag == null) ||
                    isLoading
                  }
                  leadTags={companyTagButtonProps.leadTags}
                  selectedCompanies={companyTagButtonProps.selectedCompanies}
                  selectedCompanyObjects={
                    companyTagButtonProps.selectedCompanyObjects
                  }
                  selectedAllCompanies={
                    companyTagButtonProps.selectedAllCompanies
                  }
                  companyFilter={companyTagButtonProps.companyFilter}
                  setSelectedCompanies={
                    companyTagButtonProps.setSelectedCompanies
                  }
                  setIsSelectedAllCompanies={
                    companyTagButtonProps.setIsSelectedAllCompanies
                  }
                  leadsFilter={companyTagButtonProps.leadsFilter}
                  setSavedFilters={companyTagButtonProps.setSavedFilters}
                  handleQuery={companyTagButtonProps.handleQuery}
                  triggerOpenAddTag={companyTagButtonProps.triggerOpenAddTag}
                  triggerOpenRemoveTag={
                    companyTagButtonProps.triggerOpenRemoveTag
                  }
                  onRowTagModalClosed={
                    companyTagButtonProps.onRowTagModalClosed
                  }
                  overrideSelectedCompanyObjects={
                    companyTagButtonProps.overrideSelectedCompanyObjects
                  }
                />
              )}
            {shouldShowExport && canDisplayDataExport && (
              <Button
                variant="secondary"
                disabled={isLoading || loadingBulkAction.loadingExport}
                className="btn-custom-secondary"
                onClick={() =>
                  guardExport(() =>
                    onBulkAction?.(BulkLeadsActionType.EXPORT),
                  )
                }
                isLoading={loadingBulkAction.loadingExport}
              >
                <Download />
                <span>Export</span>
              </Button>
            )}
          </div>

          {/* <div className="v2-lead-header__credit">
            <div
              className="credit-number cursor-pointer"
              role="button"
              tabIndex={0}
              data-testid="v2-lead-credits"
              onClick={() => {
                if (isDemoAccount) {
                  setGlobalRestrictionModalContent({
                    title: 'Purchasing credit is disabled in demo mode',
                    content:
                      'This is a demo account with sample data. Signup to purchase credits.',
                  });
                  setShowGlobalRestrictionModal(true);
                  return;
                }

                // if does not match this condition then only redirect
                if (!isLeadFinderViewOnly) {
                  let redirectionUrlToUpgrade =
                    '/billing/upgrade-plan/lead-finder';
                  if (
                    !hasPermission(Permissions?.LEAD_FINDER_SUBSCRIPTION_READ)
                  ) {
                    redirectionUrlToUpgrade =
                      '/billing/subscriptions/lead-finder';
                  }
                  history.push({
                    pathname: redirectionUrlToUpgrade,
                  });
                }
              }}
            >
              <Diamond className="diamond-icon" />
              <p>
                {formatLeadCredits}{' '}
                {[0, 1].includes(Number(leadCredits)) ? 'Credit' : 'Credits'}
              </p>
            </div>
          </div> */}
        </div>
      </header>
      <GlobalRestrictionModal
        show={showGlobalRestrictionModal}
        onClose={() => setShowGlobalRestrictionModal(false)}
        title={globalRestrictionModalContent.title}
        content={globalRestrictionModalContent.content}
        primaryBtnLabel="Sign up"
      />

      <RemoveFromListModal
        show={showRemoveFromListModal}
        onClose={handleCloseRemoveFromListModal}
        lists={filteredListsForRemoveModal}
        onRemoveFromList={(listIds) =>
          onRemoveFromList?.(listIds, handleCloseRemoveFromListModal)
        }
        isSubmitLoading={loadingRemoveFromList}
      />
      {exportConfirmationModal}
    </>
  );
};

export default memo(V2LeadHeader);
